import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { ArrowRightStartOnRectangleIcon } from '@heroicons/react/20/solid';
import { Sidebar as UISidebar } from '@nearst/ui';

import Sidebar from '@components/Sidebar';
import OnboardingMobileNavigator from './OnboardingMobileNavigator';
import OnboardingLocationSelector from './OnboardingLocationSelector';
import OnboardingDashboard from './OnboardingDashboard';
import OnboardingChannels from './OnboardingChannels';
import OnboardingInventory from './OnboardingInventory';
import OnboardingInsights from './OnboardingInsights';

/**
 * Navigation sidebar for the onboarding flow
 * @param {Object} props
 * @param {Object} props.shop - Shop data (can be null before shop creation)
 * @param {boolean} props.isSignedIn - Whether the user is signed in
 * @param {Function} props.onSignOut - Function to call when signing out
 * @param {boolean} props.gbpCompleted - Whether Google Business Profile is complete
 * @returns {React.JSX.Element}
 */
const OnboardingNavigation = ({ shop, isSignedIn = false, onSignOut, gbpCompleted = false }) => {
	const { key } = useLocation();
	const [mobileExpanded, setMobileExpanded] = useState(false);

	useEffect(() => {
		setMobileExpanded(false);
	}, [key]);

	// All navigation items are unlocked once Google Business Profile is complete
	const allItemsUnlocked = !!shop?.id && gbpCompleted;

	return (
		<>
			<OnboardingMobileNavigator onToggle={() => setMobileExpanded(!mobileExpanded)} mobileExpanded={mobileExpanded} shop={shop} />
			<Sidebar mobileExpanded={mobileExpanded}>
				<OnboardingLocationSelector shop={shop} />
				<Sidebar.Group>
					<OnboardingDashboard />
					<OnboardingChannels disabled={!allItemsUnlocked} />
					<OnboardingInventory disabled={!allItemsUnlocked} />
					<OnboardingInsights disabled={!allItemsUnlocked} />
				</Sidebar.Group>
				<Sidebar.Group>
					{isSignedIn ? (
						<UISidebar.Item>
							<button onClick={onSignOut}>
								<ArrowRightStartOnRectangleIcon />
								Sign out
							</button>
						</UISidebar.Item>
					) : (
						<Sidebar.Item to="/login">
							<ArrowRightStartOnRectangleIcon />
							Sign in
						</Sidebar.Item>
					)}
				</Sidebar.Group>
			</Sidebar>
		</>
	);
};

export default OnboardingNavigation;
